
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {ChartBarsImportResponse} from './ChartBarsImportResponse';
import {ChartBarsImportServerType} from '../core/ChartBarsImportServerType';
import {FieldModelChartBarsImportServerType} from '../core/ChartBarsImportServerType';

/**
 * ChartBarsImportRequest struct
 */
class ChartBarsImportRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!Date=} timeFrom
   * @param {!Date=} timeTo
   * @param {!Set=} symbolPatterns
   * @param {UUID=} symbolMapId
   * @param {!ChartBarsImportServerType=} serverType
   * @param {!string=} address
   * @param {!number=} managerLogin
   * @param {!string=} managerPassword
   * @param {number=} limit
   * @constructor
   */
  constructor (parent = new Request(), timeFrom = new Date(0), timeTo = new Date(0), symbolPatterns = new Set(), symbolMapId = null, serverType = new ChartBarsImportServerType(), address = '', managerLogin = new UInt64(0, 0), managerPassword = '', limit = null) {
    super()
    super.copy(parent)
    this.TimeFrom = timeFrom
    this.TimeTo = timeTo
    this.SymbolPatterns = symbolPatterns
    this.SymbolMapId = symbolMapId
    this.ServerType = serverType
    this.Address = address
    this.ManagerLogin = managerLogin
    this.ManagerPassword = managerPassword
    this.Limit = limit
  }

  /**
   * Copy struct (shallow copy)
   * @this {!ChartBarsImportRequest}
   * @param {!ChartBarsImportRequest} other Other struct
   * @returns {!ChartBarsImportRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.TimeFrom != null) {
      if (other.TimeFrom instanceof Date) {
        this.TimeFrom = new Date(other.TimeFrom.getTime())
      } else {
        this.TimeFrom = new Date(Math.round(other.TimeFrom / 1000000))
      }
    } else {
      this.TimeFrom = null
    }
    if (other.TimeTo != null) {
      if (other.TimeTo instanceof Date) {
        this.TimeTo = new Date(other.TimeTo.getTime())
      } else {
        this.TimeTo = new Date(Math.round(other.TimeTo / 1000000))
      }
    } else {
      this.TimeTo = null
    }
    if (other.SymbolPatterns != null) {
      this.SymbolPatterns = new Set()
      for (let item of other.SymbolPatterns) {
        if (item != null) {
          let tempItem
          tempItem = item
          this.SymbolPatterns.add(tempItem)
        } else {
          this.SymbolPatterns.add(null)
        }
      }
    } else {
      this.SymbolPatterns = null
    }
    if (other.SymbolMapId != null) {
      this.SymbolMapId = new UUID(other.SymbolMapId)
    } else {
      this.SymbolMapId = null
    }
    if (other.ServerType != null) {
      this.ServerType = ChartBarsImportServerType.fromObject(other.ServerType)
    } else {
      this.ServerType = null
    }
    if (other.Address != null) {
      this.Address = other.Address
    } else {
      this.Address = null
    }
    if (other.ManagerLogin != null) {
      this.ManagerLogin = UInt64.fromNumber(other.ManagerLogin)
    } else {
      this.ManagerLogin = null
    }
    if (other.ManagerPassword != null) {
      this.ManagerPassword = other.ManagerPassword
    } else {
      this.ManagerPassword = null
    }
    if (other.Limit != null) {
      this.Limit = UInt64.fromNumber(other.Limit)
    } else {
      this.Limit = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!ChartBarsImportRequest}
   * @returns {!ChartBarsImportRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new ChartBarsImportRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new ChartBarsImportRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!ChartBarsImportRequest}
   * @param {!ChartBarsImportRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ChartBarsImportRequest)) {
      throw new TypeError('Instance of ChartBarsImportRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!ChartBarsImportRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      TimeFrom: ((this.TimeFrom != null) ? (this.TimeFrom.getTime() * 1000000) : null),
      TimeTo: ((this.TimeTo != null) ? (this.TimeTo.getTime() * 1000000) : null),
      SymbolPatterns: ((this.SymbolPatterns != null) ? Array.from(this.SymbolPatterns, item => ((item != null) ? item : null)) : null),
      SymbolMapId: ((this.SymbolMapId != null) ? this.SymbolMapId.toString() : null),
      ServerType: ((this.ServerType != null) ? this.ServerType : null),
      Address: ((this.Address != null) ? this.Address : null),
      ManagerLogin: ((this.ManagerLogin != null) ? this.ManagerLogin.toNumber() : null),
      ManagerPassword: ((this.ManagerPassword != null) ? this.ManagerPassword : null),
      Limit: ((this.Limit != null) ? this.Limit.toNumber() : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return ChartBarsImportRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!ChartBarsImportRequest} other Object value
   * @returns {!ChartBarsImportRequest} Created struct
   */
  static fromObject (other) {
    return new ChartBarsImportRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!ChartBarsImportRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return ChartBarsImportRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!ChartBarsImportRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 6457
  }
}

export { ChartBarsImportRequest };

/**
 * Fast Binary Encoding ChartBarsImportRequest field model
 */
class FieldModelChartBarsImportRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.TimeFrom = new fbe.FieldModelTimestamp(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.TimeTo = new fbe.FieldModelTimestamp(buffer, this.TimeFrom.fbeOffset + this.TimeFrom.fbeSize)
    this.SymbolPatterns = new fbe.FieldModelSet(new fbe.FieldModelString(buffer, this.TimeTo.fbeOffset + this.TimeTo.fbeSize), buffer, this.TimeTo.fbeOffset + this.TimeTo.fbeSize)
    this.SymbolMapId = new fbe.FieldModelOptional(new fbe.FieldModelUUID(buffer, this.SymbolPatterns.fbeOffset + this.SymbolPatterns.fbeSize), buffer, this.SymbolPatterns.fbeOffset + this.SymbolPatterns.fbeSize)
    this.ServerType = new FieldModelChartBarsImportServerType(buffer, this.SymbolMapId.fbeOffset + this.SymbolMapId.fbeSize)
    this.Address = new fbe.FieldModelString(buffer, this.ServerType.fbeOffset + this.ServerType.fbeSize)
    this.ManagerLogin = new fbe.FieldModelUInt64(buffer, this.Address.fbeOffset + this.Address.fbeSize)
    this.ManagerPassword = new fbe.FieldModelString(buffer, this.ManagerLogin.fbeOffset + this.ManagerLogin.fbeSize)
    this.Limit = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this.ManagerPassword.fbeOffset + this.ManagerPassword.fbeSize), buffer, this.ManagerPassword.fbeOffset + this.ManagerPassword.fbeSize)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelChartBarsImportRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelChartBarsImportRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelChartBarsImportRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.TimeFrom.fbeSize + this.TimeTo.fbeSize + this.SymbolPatterns.fbeSize + this.SymbolMapId.fbeSize + this.ServerType.fbeSize + this.Address.fbeSize + this.ManagerLogin.fbeSize + this.ManagerPassword.fbeSize + this.Limit.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelChartBarsImportRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.TimeFrom.fbeExtra + this.TimeTo.fbeExtra + this.SymbolPatterns.fbeExtra + this.SymbolMapId.fbeExtra + this.ServerType.fbeExtra + this.Address.fbeExtra + this.ManagerLogin.fbeExtra + this.ManagerPassword.fbeExtra + this.Limit.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelChartBarsImportRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelChartBarsImportRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelChartBarsImportRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 6457
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelChartBarsImportRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelChartBarsImportRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.TimeFrom.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TimeFrom.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TimeFrom.fbeSize

    if ((fbeCurrentSize + this.TimeTo.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TimeTo.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TimeTo.fbeSize

    if ((fbeCurrentSize + this.SymbolPatterns.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SymbolPatterns.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolPatterns.fbeSize

    if ((fbeCurrentSize + this.SymbolMapId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SymbolMapId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolMapId.fbeSize

    if ((fbeCurrentSize + this.ServerType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ServerType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ServerType.fbeSize

    if ((fbeCurrentSize + this.Address.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Address.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Address.fbeSize

    if ((fbeCurrentSize + this.ManagerLogin.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ManagerLogin.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ManagerLogin.fbeSize

    if ((fbeCurrentSize + this.ManagerPassword.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ManagerPassword.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ManagerPassword.fbeSize

    if ((fbeCurrentSize + this.Limit.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Limit.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Limit.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelChartBarsImportRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelChartBarsImportRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelChartBarsImportRequest}
   * @param {!ChartBarsImportRequest} fbeValue Default value, defaults is new ChartBarsImportRequest()
   * @returns {!ChartBarsImportRequest} ChartBarsImportRequest value
   */
  get (fbeValue = new ChartBarsImportRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelChartBarsImportRequest}
   * @param {!ChartBarsImportRequest} fbeValue ChartBarsImportRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.TimeFrom.fbeSize) <= fbeStructSize) {
      fbeValue.TimeFrom = this.TimeFrom.get()
    } else {
      fbeValue.TimeFrom = new Date(0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TimeFrom.fbeSize

    if ((fbeCurrentSize + this.TimeTo.fbeSize) <= fbeStructSize) {
      fbeValue.TimeTo = this.TimeTo.get()
    } else {
      fbeValue.TimeTo = new Date(0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TimeTo.fbeSize

    if ((fbeCurrentSize + this.SymbolPatterns.fbeSize) <= fbeStructSize) {
      this.SymbolPatterns.get(fbeValue.SymbolPatterns)
    } else {
      fbeValue.SymbolPatterns.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolPatterns.fbeSize

    if ((fbeCurrentSize + this.SymbolMapId.fbeSize) <= fbeStructSize) {
      fbeValue.SymbolMapId = this.SymbolMapId.get()
    } else {
      fbeValue.SymbolMapId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolMapId.fbeSize

    if ((fbeCurrentSize + this.ServerType.fbeSize) <= fbeStructSize) {
      fbeValue.ServerType = this.ServerType.get()
    } else {
      fbeValue.ServerType = new ChartBarsImportServerType()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ServerType.fbeSize

    if ((fbeCurrentSize + this.Address.fbeSize) <= fbeStructSize) {
      fbeValue.Address = this.Address.get()
    } else {
      fbeValue.Address = ''
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Address.fbeSize

    if ((fbeCurrentSize + this.ManagerLogin.fbeSize) <= fbeStructSize) {
      fbeValue.ManagerLogin = this.ManagerLogin.get()
    } else {
      fbeValue.ManagerLogin = new UInt64(0, 0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ManagerLogin.fbeSize

    if ((fbeCurrentSize + this.ManagerPassword.fbeSize) <= fbeStructSize) {
      fbeValue.ManagerPassword = this.ManagerPassword.get()
    } else {
      fbeValue.ManagerPassword = ''
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ManagerPassword.fbeSize

    if ((fbeCurrentSize + this.Limit.fbeSize) <= fbeStructSize) {
      fbeValue.Limit = this.Limit.get()
    } else {
      fbeValue.Limit = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Limit.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelChartBarsImportRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelChartBarsImportRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelChartBarsImportRequest}
   * @param {!ChartBarsImportRequest} fbeValue ChartBarsImportRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelChartBarsImportRequest}
   * @param {ChartBarsImportRequest} fbeValue ChartBarsImportRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.TimeFrom.set(fbeValue.TimeFrom)
    this.TimeTo.set(fbeValue.TimeTo)
    this.SymbolPatterns.set(fbeValue.SymbolPatterns)
    this.SymbolMapId.set(fbeValue.SymbolMapId)
    this.ServerType.set(fbeValue.ServerType)
    this.Address.set(fbeValue.Address)
    this.ManagerLogin.set(fbeValue.ManagerLogin)
    this.ManagerPassword.set(fbeValue.ManagerPassword)
    this.Limit.set(fbeValue.Limit)
  }
}

export { FieldModelChartBarsImportRequest };

/**
 * Fast Binary Encoding ChartBarsImportRequest model
 */
class ChartBarsImportRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelChartBarsImportRequest(this.buffer, 4)
  }

  /**
   * Get the ChartBarsImportRequest model
   * @this {!ChartBarsImportRequestModel}
   * @returns {!FieldModelChartBarsImportRequest} model ChartBarsImportRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!ChartBarsImportRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!ChartBarsImportRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return ChartBarsImportRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!ChartBarsImportRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelChartBarsImportRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!ChartBarsImportRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!ChartBarsImportRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!ChartBarsImportRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!ChartBarsImportRequestModel}
   * @param {!ChartBarsImportRequest} value ChartBarsImportRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!ChartBarsImportRequestModel}
   * @param {!ChartBarsImportRequest} value ChartBarsImportRequest value, defaults is new ChartBarsImportRequest()
   * @return {!object} Deserialized ChartBarsImportRequest value and its size
   */
  deserialize (value = new ChartBarsImportRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new ChartBarsImportRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new ChartBarsImportRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!ChartBarsImportRequestModel}
   * @param {!number} prev Previous ChartBarsImportRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { ChartBarsImportRequestModel };
ChartBarsImportRequest.__has_response = true;
ChartBarsImportRequest.__response_class = ChartBarsImportResponse;
